import pendingSubmissionsCountSelectorFactory from '../../gridReport/pendingSubmissionsCountSelectorFactory';
import { isAllowedToMakeDirectEntriesSelectorFactory } from '../../store/selectors';

export const selectReportData = ({ balanceSheetManagement }) => balanceSheetManagement.taxLifecycle.reportData;

export const selectIsFetchingTaxLifecycleReport = ({ balanceSheetManagement }) =>
  balanceSheetManagement.taxLifecycle.isFetchingReportData;

export const isExportingTaxLifecycleReportSelector = ({ balanceSheetManagement }) =>
  balanceSheetManagement.taxLifecycle.isExportingReport;

export const pendingSubmissionsCountSelector = ({ balanceSheetManagement }) =>
  pendingSubmissionsCountSelectorFactory(balanceSheetManagement.taxLifecycle.reportData);

export const isAllowedToMakeDirectEntriesSelector = isAllowedToMakeDirectEntriesSelectorFactory({
  checkAggregationDroplistValue: false,
});

export const obligationsSelector = ({ administration }) =>
  administration.obligations.obligations;

export const periodOrCurrentSelector = ({ shared }) => shared.period || shared.currentPeriod;
